
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/document/[...productId]",
      function () {
        return require("private-next-pages/document/[...productId]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/document/[...productId]"])
      });
    }
  